"use client"
/* */
const alert = "flow--alert";
const icon = "flow--alert--icon";
const content = "flow--alert--content";
const info = "flow--alert--info";
const heading = "flow--alert--heading";
const warning = "flow--alert--warning";
const danger = "flow--alert--danger";
const success = "flow--alert--success";
const styles = {
	alert: alert,
	icon: icon,
	content: content,
	info: info,
	heading: heading,
	warning: warning,
	danger: danger,
	success: success
};

export { alert, content, danger, styles as default, heading, icon, info, success, warning };
//# sourceMappingURL=Alert.module.scss.mjs.map
